import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { linkFor, pageLanguage, withoutLanguage } from '../content/publicLanguages';
import { useTranslation } from 'react-i18next';
import PublicLanguageSelect from './PublicLanguageSelect';

const PublicNavbar = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const language = pageLanguage(location.pathname, i18n);
  const home = linkFor('/', language);
  const blog = linkFor('/blog', language);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isBlogRoute = withoutLanguage(location.pathname).startsWith('/blog');
  const isHomeRoute = withoutLanguage(location.pathname) === '/';
  const featuresHref = isHomeRoute ? '#how' : `${home}#how`;
  const pricingHref = isHomeRoute ? '#pricing' : `${home}#pricing`;
  const financeHref = isHomeRoute ? '#finance' : `${home}#finance`;

  useEffect(() => {
    document.body.classList.toggle('public-nav-open', isMenuOpen);

    return () => {
      document.body.classList.remove('public-nav-open');
    };
  }, [isMenuOpen]);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="navbar">
      <div className="navbar-inner">
        <Link to={home} className="navbar-brand" aria-label={t('public.nav.home_aria')}>
          <img src="/Logo.png" alt="UpyaChat logo" className="navbar-logo" />
          <span className="navbar-name">UpyaChat</span>
        </Link>

        <nav className="navbar-links" aria-label={t('public.nav.primary_aria')}>
          <a href={featuresHref} className="navbar-link">
            {t('public.nav.features')}
          </a>
          <a href={pricingHref} className="navbar-link">
            {t('public.nav.pricing')}
          </a>
          <a href={financeHref} className="navbar-link">
            {t('public.nav.finance')}
          </a>
        </nav>

        <div className="public-header-actions">
          <Link to={blog} className={`navbar-link${isBlogRoute ? ' navbar-link--active' : ''}`}>
            {t('public.nav.blog')}
          </Link>
          <PublicLanguageSelect />
          <Link to="/login" className="navbar-link navbar-link--auth">
            {t('public.nav.login')}
          </Link>
          <Link to="/login" className="navbar-cta">
            {t('public.nav.try_for_free')}
          </Link>
        </div>

        <div className="navbar-mobile-controls">
          <Link to="/login" className="navbar-mobile-cta">
            {t('public.nav.try_for_free')}
          </Link>
          <button
            type="button"
            className={`navbar-menu-toggle${isMenuOpen ? ' is-open' : ''}`}
            aria-label={t('public.nav.menu_toggle')}
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen((value) => !value)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="navbar-mobile-panel">
          <a href={featuresHref} className="navbar-mobile-link" onClick={() => setIsMenuOpen(false)}>
            {t('public.nav.features')}
          </a>
          <a href={pricingHref} className="navbar-mobile-link" onClick={() => setIsMenuOpen(false)}>
            {t('public.nav.pricing')}
          </a>
          <a href={financeHref} className="navbar-mobile-link" onClick={() => setIsMenuOpen(false)}>
            {t('public.nav.finance')}
          </a>
          <Link to={blog} className="navbar-mobile-link" onClick={() => setIsMenuOpen(false)}>
            {t('public.nav.blog')}
          </Link>
          <Link to="/login" className="navbar-mobile-link" onClick={() => setIsMenuOpen(false)}>
            {t('public.nav.login')}
          </Link>
          <div className="navbar-mobile-language">
            <span className="navbar-mobile-language-label">{t('public.language.mobile_label')}</span>
            <PublicLanguageSelect />
          </div>
          <Link to="/login" className="navbar-mobile-panel-cta" onClick={() => setIsMenuOpen(false)}>
            {t('public.nav.try_for_free')}
          </Link>
        </div>
      )}
    </header>
  );
};

export default PublicNavbar;
